import { FAST_API_URL } from "@/shared/config/player";
import { AllSubscriptionData } from "./types";

export const downloadFileApi = async (file_name: string) => {
    const response = await fetch(
        `${FAST_API_URL}/download_rus?file_name=${file_name}`,
    );
    if (!response.ok) {
        throw new Error("cant download rus audio");
    }
    return response.blob();
};

export const getAllDataForEditingApi = async ({
    mediaId,
    lang,
}: {
    mediaId: string;
    lang: string;
}): Promise<AllSubscriptionData[]> => {
    const response = await fetch(
        `${FAST_API_URL}/get_all_data_for_editing?media=${mediaId}&lang=${lang}`,
    );
    if (!response.ok) {
        throw new Error("cant get all data for Editing");
    }
    return await response.json();
};

export const getVideoPlaylistApi = async ({
    mediaId,
}: {
    mediaId: string;
}): Promise<AllSubscriptionData[]> => {
    const response = await fetch(
        `${FAST_API_URL}/streaming/vod_playlist?media=${mediaId}`,
    );
    if (!response.ok) {
        throw new Error("cant get all data for Editing");
    }
    return await response.json();
};
